import type { ReactNode } from 'react'

type RegisterAuthFieldProps = {
  field?: string
  error?: string
  className?: string
  label: ReactNode
  children: ReactNode
}

export const RegisterAuthField = ({
  field,
  error,
  className = '',
  label,
  children,
}: RegisterAuthFieldProps) => {
  const errorId = field ? `register-${field}-error` : undefined

  return (
    <label
      className={`market-auth-field market-auth-field--compact${error ? ' market-auth-field--invalid' : ''}${className ? ` ${className}` : ''}`}
      data-field={field}
    >
      <span className="market-auth-field__label">{label}</span>
      {children}
      {error ? (
        <span className="market-auth-field__error" id={errorId} role="alert">
          {error}
        </span>
      ) : null}
    </label>
  )
}
